export default __webpack_public_path__ + "static/media/berliner-series.24ad24c6.webp";